import { render, staticRenderFns } from "./CollapsibleArticle.vue?vue&type=template&id=3cab4690&"
import script from "./CollapsibleArticle.vue?vue&type=script&lang=js&"
export * from "./CollapsibleArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports